import React, { Component } from "react";

import TeachersGrid from "./../component/TeachersGrid";
import MySelect from "./../component/select";

class Deeplearn extends Component {
  handelSelect = e => {
    if (e.name === "subject") this.props.setSubject(e.value);
    if (e.name === "class") this.props.setClass(e.value);
  };
  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.setSubject(null);
    this.props.setClass(null);
  }
  componentWillUnmount() {}

  render() {
    return (
      <div className="deep">
        <img
          className="img"
          src="https://imdproc-uploads-prod.s3.amazonaws.com/upload/custom-pages/im-ognakan/way/deep.cut.jpg"
          alt=""
        />
        <div className="intro">
          <h1 className="header text-center">Առարկայի խորացված ուսուցում</h1>
          <p>
            Սիրելի՛ ծնողներ, ձեզ ենք ներկայացնում մի ծրագիր, որի շրջանակներում
            յուրաքանչյուր աշակերտ հնարավորություն կստանա իր գիտելիքները
            կառուցելու ճանապարհին ուղղորդվել այնպիսի մասնագետների կողմից, ովքեր
            լավագույններից են Հայաստանում։ Եվ այս ամենը օնլայն հարթակում՝ առանց
            տնից դուրս գալու։ Երեխայի գիտելիքները ստուգելուց անմիջապես հետո
            ուսուցիչը կսկսի անհատական աշխատանք նրա հետ (երեխան սովորելու է ոչ
            միայն իր դասարանի ծրագրով նախատեսված նյութը, այլև անհրաժեշտության
            դեպքում վերհիշելու և ամրապնդելու է նախորդ տարիների անցածը)։
          </p>
        </div>

        <h3 className="header text-center">Ընտրեք դասարանն ու առարկան</h3>

        <div className="col-sm-3 " />
        <div className="col-sm-3 ">
          <MySelect
            name="subject"
            onChange={this.handelSelect}
            default="Առարկա"
            options={[
              "Մայրենի",
              "Մաթեմատիկա",
              "Անգլերեն",
              "Անգլ. բանավոր",
              "Բնագիտություն",
              "Կենսաբանություն",
              "Հայոց լեզու",
              "Հանրահաշիվ",
              "Երկրաչափություն",
              "Ֆիզիկա",
              "Քիմիա",
              "Ռուսաց լեզու",
              "Աշխարհագրություն"
            ]}
          />
        </div>
        <div className="col-sm-3 ">
          <MySelect
            name="class"
            onChange={this.handelSelect}
            default="Դասարան"
            options={["5", "6", "7", "8", "9", "10"]}
          />
        </div>
        <div className="col-sm-3" />
        <div className="polaceholder" />

        {this.props.classNumber && this.props.subject ? (
          <TeachersGrid
            classNumber={this.props.classNumber}
            subject={this.props.subject}
            setTeacher={this.props.setTeacher}
          />
        ) : (
          <div />
        )}
      </div>
    );
  }
}

export default Deeplearn;
